import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Progress14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_187)'>
      <path
        d='M12.25 7C12.25 4.1005 9.89952 1.75 7.00002 1.75C6.64844 1.75 6.30565 1.78445 5.9746 1.84995L5.6835 0.378463C6.1099 0.294109 6.55018 0.25 7.00002 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7.00002 13.75C6.55018 13.75 6.1099 13.7059 5.6835 13.6215L5.9746 12.1501C6.30565 12.2155 6.64844 12.25 7.00002 12.25C9.89952 12.25 12.25 9.8995 12.25 7Z'
        fill='currentColor'
      />
      <path
        d='M3.24909 12.6126C2.51332 12.12 1.87999 11.4867 1.3874 10.7509L2.63386 9.91646C3.01737 10.4893 3.51072 10.9827 4.08357 11.3662L3.24909 12.6126Z'
        fill='currentColor'
      />
      <path
        d='M1.3874 3.24907C1.87999 2.51329 2.51331 1.87997 3.24909 1.38738L4.08357 2.63383C3.51072 3.01734 3.01736 3.5107 2.63386 4.08355L1.3874 3.24907Z'
        fill='currentColor'
      />
      <path
        d='M0.378486 5.68348L1.84997 5.97458C1.71899 6.63667 1.71899 7.36333 1.84997 8.02542L0.378486 8.31652C0.209776 7.46372 0.209775 6.53628 0.378486 5.68348Z'
        fill='currentColor'
      />
      <path
        d='M6.00008 9.56066L10.0304 5.53033L8.96975 4.46967L6.00008 7.43934L5.03041 6.46967L3.96975 7.53033L6.00008 9.56066Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_187'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='matrix(0 1 -1 0 14 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Progress14.displayName = 'Progress14';
export default Progress14;
